<template>
  <div class="">
    <div class="flex flex-wrap justify-between mb-30 mb-db mb-tc">
      <h2 class="fs-36 fw-900 ttc mb-fs-28">{{ countryName }} Travel Inspiration</h2>
      <div class="mb-dn">
        <a :href="toBlogPage" class="button-blog fs-14 fw-700 br-14 lh-16 hand" target="_blank"> See All Posts </a>
      </div>
    </div>
    <div class="overflow-auto">
      <div class="flex mb-5 mb-mb-30">
        <div class="item wp-33-3 mb-wp-100" v-for="(item, index) in listBlogPost" :key="index">
          <div class="h-170 relative mb-21 hand overflow-hidden br-14">
            <a :href="item.link" :title="item.title" target="_blank">
              <div class="absolute wp-100 hp-100 bg-linear-gradient-2"></div>
              <img loading="lazy" class="img-cover" :src="item.thumbnail" alt="" />
              <div class="absolute bottom-0 left-0 right-0 white pb-20 pl-20 pr-20 fs-20 lh-1 fw-700 mb-fs-16">
                {{ item.title }}
              </div>
            </a>
          </div>
          <div class="pl-20 pr-20">
            <div class="fw-700 fs-12 mb-20 gray-dark">
              <span class="mr-20 dib lh-15"
                >written by <span class="blue-branding">{{ item.author }}</span></span
              >
              <span class="dib lh-15">{{ formatDate(item.date, 'm d Y') }}</span>
            </div>
            <div class="fs-14 lh-18 di text-excerpt" v-html="item.content"></div>
            <a :href="item.link" target="_blank"><span class="black fw-700 underline hand fs-14">read more</span></a>
          </div>
        </div>
      </div>
    </div>
    <div class="dn mb-db tc">
      <a :href="toBlogPage" class="button-blog fs-14 fw-700 br-14 lh-16 hand dib"> See All Posts </a>
    </div>
  </div>
</template>
<script setup>
import { computed, ref, watch } from 'vue'
import galleryApi from '~/composables/api/galleryApi'
import { formatDate } from '~/helper'

// ---Props & Emit---
const props = defineProps({
  category: {
    type: String,
    required: true,
  },
  countryName: {
    type: String,
    required: true,
  },
})
const emit = defineEmits(['hiddenBlog'])

// ---Define---
const listBlogPost = ref([])

// ---Computed
const toBlogPage = computed(() => {
  return useRuntimeConfig().public.publicDomain + `/blog/category/${props.category}/`
})

// ---Method
const getBlogPost = async () => {
  let category = props.category
  const repCategory = category.replace(/-and/g, '')
  let params = {
    category: repCategory,
    limit: 3,
  }
  try {
    const { data: res } = await galleryApi.getBlogPost(params)
    listBlogPost.value = res.value.data
    emit('hiddenBlog', listBlogPost.value.length)
  } catch (e) {
    emit('hiddenBlog', 0)
    console.log(e)
  }
}

// ---Watch---
// watch(
//   () => props.category,
//   async () => {
//     listBlogPost.value = []
//     await getBlogPost()
//   },
// )

// ---Mouted---
onMounted(()=>{
  nextTick(()=> getBlogPost())
})
</script>
<style lang="scss" scoped>
.item {
}
.text-excerpt {
  :deep(p:last-child) {
    line-height: 18px;
  }
}
.item {
  margin-right: 40px;
  &:last-child {
    margin-right: 0;
  }
  @media (min-width: 600px) and (max-width: 900px) {
    width: 50%;
    margin-right: 0;
    &:last-child {
      display: none;
    }
    &:first-child {
      margin-right: 20px;
      display: block;
    }
  }
  @media (max-width: 599px) {
    display: none;
    &:first-child {
      display: block;
      margin-right: 0;
    }
  }
}
.button-blog {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 123px;
  height: 40px;
  font-size: 14px;
  line-height: 16px;
  color: $gray-dark;
  border: 1px solid $gray-medium;
  margin: auto;
  &:hover {
    background-color: #f1f1f1;
    border-color: #f1f1f1;
    color: grey;
  }
}
</style>
